module.exports = __webpack_public_path__ + "static/media/3.4dc05aa2.png";